<app-page-header [heading]="'Supplier'" [icon]="'fa-industry'" style="height:100px;"></app-page-header>

<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="row col-lg-12">
    <div class="col-lg-3">
      <label>Code</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="vendor_data.vendor_code" class="form-control " maxlength="15"
             name="vendor_code" readonly
             type="text">
    </div>
    <div class="col-lg-3">
      <label>Name</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="vendor_data.vendor_name" class="form-control " maxlength="100"
             name="trade_name"
             type="text">
    </div>
    <div class="col-lg-3">
      <label>Phone Number</label>
      <input [(ngModel)]="vendor_data.vendor_phoneno" class="form-control " maxlength="100"
             name="scientific_code"
             type="text">
    </div>
    <div class="col-lg-3">
      <label>Address</label>
      <textarea [(ngModel)]="vendor_data.vendor_address" class="form-control " maxlength="100"
                name="scientific_name"
                type="text"></textarea>
    </div>

    <div class="col-lg-3">
      <label>Email</label>
      <input [(ngModel)]="vendor_data.vendor_email" class="form-control " id="" maxlength="50"
             name="ingredient_strength"
             type="text">
    </div>
    <div class="col-lg-3">
      <label>Credit Period</label>
      <div class="input-group ">
        <input [(ngModel)]="vendor_data.credit_period" [appOnlyNumber]="true" class="form-control" maxlength="5"
               style="height:29px" type="text">
        <div class="input-group-append">
          <label class="input-group-text day">
            (Days)
          </label>
        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <label>VAT No</label>
      <input [(ngModel)]="vendor_data.vendor_vat" class="form-control " maxlength="20" name="vendor_vat"
             type="text">
    </div>

    <div class="col-lg-3">
      <label>Supplier Document</label>
      <div>
        <input #file (change)="getFileDetails($event)" [(ngModel)]="vendor_data.document"
               accept=".jpg, .jpeg, .pdf, .png" class="inputfile"
               id="file" name="document"
               type="file">
        <label for="file">&nbsp;&nbsp;<i class="fa fa-upload">&nbsp;&nbsp;&nbsp;</i>Choose a file&nbsp;&nbsp;&nbsp;&nbsp;</label>&nbsp;
        <i><a href="{{filePath(fileName)}}" style="font-size:12px" target="_blank">{{ fileName }}</a></i>
        <button (click)="removeFile()" *ngIf="fileName != '' && fileName != null" class="btn btn-small"><i
          class="fa fa-trash text-danger" style="font-size:12px"></i></button>
      </div>
    </div>
    <div class="col-lg-3">
      <label for="cash">Payment</label>
      <div class="col-12">
        <label class="checkbox-inline" for="cash">
          <input (click)="selectCoinPaymentType(1)" [checked]="vendor_data.payment_type == 1" id="cash"
                 name="payment_type" type="radio"
                 value="1">&nbsp;&nbsp;Cash
        </label>&nbsp;&nbsp;
        <label class="checkbox-inline" for="cheque">
          <input (click)="selectCoinPaymentType(0)" [checked]="vendor_data.payment_type == 0" id="cheque"
                 name="payment_type" type="radio"
                 value="0">&nbsp;&nbsp;Cheque
        </label>&nbsp;
          <label class="checkbox-inline" for="online">
              <input (click)="selectCoinPaymentType(2)" [checked]="vendor_data.payment_type == 2" id="online"
                     name="payment_type" type="radio"
                     value="2">&nbsp;&nbsp;Online
          </label>
      </div>
    </div>

  </div>
  <div class="clearfix"></div>
  <div class="row container">
    <div class="col-lg-7 pull-right">
      <button (click)="saveVendor();" *ngIf="user_rights.ADD == '1'" class="btn btn-info btn-sm ng-star-inserted"
              type="button">&nbsp;Save&nbsp;
      </button>&nbsp;&nbsp;&nbsp;
      <button (click)="clearvendor();" *ngIf="user_rights.ADD == '1'" class="btn btn-danger btn-sm" type="button">
        &nbsp;Clear&nbsp;
      </button>
    </div>
  </div>
  <div class="clearfix"></div>
</div>

<div class="page-break ">
  <div class=" row">
    <div class="col-lg-8">
      <h4 class="list-header">Supplier List</h4>
    </div>
    <div class="col-lg-4">
      <div class="input-group ">
        <input (keydown)="keyDownFunction($event)" [(ngModel)]="vendor_data.search_vendor" class="form-control"
               id="typeahead-http"
               name="search_text" placeholder="Supplier Name / Code ..." style="height:31px"
               type="text">
        <div class="input-group-append">
          <button (click)="clear_search()" class="input-group-text" style="height:31px;padding:7px">
            <i *ngIf="vendor_data.search_vendor != ''" class="fa fa-close"></i>
            <i *ngIf="vendor_data.search_vendor == ''" class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <div *ngIf="this.status == 'Failed'"><span [hidden]="this.status == 'Success'"
                                                 style="color:red;font-size:13px;"> Sorry, suggestions could not be loaded.</span>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
  <div class="">
    <table class="table tbl table-hover table-striped table-bordered">
      <thead>
      <tr>
        <th width="1%">#</th>
        <th width="10%">Code</th>
        <th width="20%">Name /Phone /Email</th>
        <th width="30%">Address</th>
        <th>VAT No</th>
        <th>Document</th>
        <th width="10%" class="text-center">Action</th>
      </tr>
      <tr *ngIf="(vendors_data | json) == '[]'">
        <td class="text-center" colspan="10">No data to list</td>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of vendors_data;let i=index" style="font-size: 12px">
        <td>{{ start + i + 1 }}</td>
        <td>{{ data.VENDOR_CODE }}</td>
        <td>{{ data.VENDOR_NAME }}<br>{{ data.VENDOR_PHONE }}<br>{{data.VENDOR_EMAIL}}</td>
        <td>{{ data.VENDOR_ADDRESS }}</td>
        <td>{{ data.TRN_NO }}</td>
        <td><a href="{{filePath(data.VENDOR_DOCUMENT)}}" target="_blank"
               title="{{ data.VENDOR_DOCUMENT }}">{{ data.VENDOR_DOCUMENT }}</a></td>
        <td class="text-center">
          <button (change)="getFileDetails(data.VENDOR_DOCUMENT)" (click)="editVendor(data);"
                  *ngIf="user_rights.EDIT=='1'" alt="Edit" class="btn btn-sm btn-default" title="Edit"><i
            class="fa fa-edit"></i></button>
            &nbsp;&nbsp;
            <button (click)="deleteVendor(data.VENDOR_ID);" *ngIf="user_rights.DELETE == '1'" alt="Delete"
              class="btn btn-sm btn-danger" style="font-size: 10px" title="Delete"><i class="fa fa-trash"></i></button>
        </td>
      </tr>
      </tbody>
    </table>
    <app-pagination (pageChange)="getVendorList($event)" [pageSize]="p" [page]="page" [recordCount]="collection"/>
  </div>
</div>


